var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOfUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9741 25.9577H6.74049C6.07482 25.9577 5.53516 25.4134 5.53516 24.7421V2.21559C5.53516 1.54425 6.07482 1 6.74049 1H17.9741C18.6398 1 19.1794 1.54425 19.1794 2.21559V24.7421C19.1794 25.4134 18.6398 25.9577 17.9741 25.9577Z",
    stroke: "#A71720",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0086 2.5625H7.52204C7.32649 2.5625 7.16797 2.72237 7.16797 2.91958V5.08348C7.16797 5.28069 7.32649 5.44056 7.52204 5.44056H17.0086C17.2041 5.44056 17.3627 5.28069 17.3627 5.08348V2.91958C17.3627 2.72237 17.2041 2.5625 17.0086 2.5625Z",
    stroke: "#A71720",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0086 6.44531H7.52204C7.32649 6.44531 7.16797 6.60518 7.16797 6.80239V8.96629C7.16797 9.1635 7.32649 9.32337 7.52204 9.32337H17.0086C17.2041 9.32337 17.3627 9.1635 17.3627 8.96629V6.80239C17.3627 6.60518 17.2041 6.44531 17.0086 6.44531Z",
    stroke: "#A71720",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0086 10.3125H7.52204C7.32649 10.3125 7.16797 10.4724 7.16797 10.6696V12.8335C7.16797 13.0307 7.32649 13.1906 7.52204 13.1906H17.0086C17.2041 13.1906 17.3627 13.0307 17.3627 12.8335V10.6696C17.3627 10.4724 17.2041 10.3125 17.0086 10.3125Z",
    stroke: "#A71720",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6603 13.875H15.3926C15.2319 13.875 15.1016 14.0064 15.1016 14.1685V14.4324C15.1016 14.5945 15.2319 14.7259 15.3926 14.7259H16.6603C16.821 14.7259 16.9513 14.5945 16.9513 14.4324V14.1685C16.9513 14.0064 16.821 13.875 16.6603 13.875Z",
    fill: "#A71720"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3183 18.1243C16.9363 18.1243 17.4373 17.619 17.4373 16.9958C17.4373 16.3725 16.9363 15.8672 16.3183 15.8672C15.7002 15.8672 15.1992 16.3725 15.1992 16.9958C15.1992 17.619 15.7002 18.1243 16.3183 18.1243Z",
    stroke: "#A71720",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2811 29.4453H9.36675C9.29149 29.4453 9.23047 29.5068 9.23047 29.5828V31.8585C9.23047 31.9345 9.29149 31.996 9.36675 31.996H15.2811C15.3564 31.996 15.4174 31.9345 15.4174 31.8585V29.5828C15.4174 29.5068 15.3564 29.4453 15.2811 29.4453Z",
    stroke: "#A71720",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2969 25.9609V29.4537",
    stroke: "#A71720",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 30.7266H9.22986",
    stroke: "#A71720",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1341 30.7266H15.418",
    stroke: "#A71720",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOfUser);
export default __webpack_public_path__ + "static/media/NoOfUser.c9144c781b3700c9f3ee900c377d6a88.svg";
export { ForwardRef as ReactComponent };